// extracted by mini-css-extract-plugin
export default {"heading":"clipBoard_heading__hgi-C","button":"clipBoard_button__OLd8F"};